import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { find, save, remove, list2, checklupp } from '../../services/inventoryProductInformation'

// function* fetchInventoryProductInformationsRefresh() {
//   const fe = JSON.parse(localStorage.getItem('fetchInventoryProductInformations'))
//   if (fe == null) {
//     fe.size = localStorage.getItem('pageSize') || 15
//     fe.index = 0
//     fe.searchTerm = '%20'
//     fe.orderBy = '%20'
//   }
//   yield put({
//     type: actions.REQUESTING,
//   })
//   const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
//   yield put({
//     type: actions.LIST_INVENTORYPRODUCTINFORMATION,
//     result,
//   })
// }

// function* fetchInventoryProductInformations({ size, index, searchTerm, orderBy }) {
//   // Load last params froom last session.
//   if (!size && !index && !searchTerm && !orderBy) {
//     const fe = null
//     if (fe != null) {
//       size = fe.size || 15
//       index = fe.index || 0
//       searchTerm = fe.searchTerm || '%20'
//       orderBy = fe.orderBy || '%20'
//     } else {
//       size = size || localStorage.getItem('pageSize') || 15
//       index = 0
//       searchTerm = '%20'
//       orderBy = '%20'
//     }
//   }
//   localStorage.setItem(
//     'fetchInventoryProductInformations',
//     JSON.stringify({ size, index, searchTerm, orderBy }),
//   )
//   yield put({
//     type: actions.REQUESTING,
//   })
//   const result = yield call(list, size, index, searchTerm, orderBy)
//   yield put({
//     type: actions.LIST_INVENTORYPRODUCTINFORMATION,
//     result,
//   })
// }

function* fetchInventoryProductInformationEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_INVENTORYPRODUCTINFORMATION,
    result,
  })
}

function* saveMlfb(values) {
  yield put({
    type: actions.REQUESTING,
  })

  const result2 = yield call(checklupp, values)
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
    if(values.values.inventoryProductInformationID === 0 && values.values.createAlsoInOtherContract === true){
      if (result2 !== null) {
        if (result2 === "LuppHas") {
          notification.info({ message: 'Information', description: 'LUPP has this mlfb number.' })
        }
        if (result2 === "LuppHasNot") {
          notification.success({ message: SAVE_200_MSG, description: 'MLFB created also in LUPP.' })
        }
      } 
    }
  }
 
  yield put({
    type: actions.SAVE_INVENTORYPRODUCTINFORMATION_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_INVENTORYPRODUCTINFORMATIONS,
  })
}

function* fetchInventoryProductInformationDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_INVENTORYPRODUCTINFORMATION_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_INVENTORYPRODUCTINFORMATIONS,
  })
}

function* fetchInventoryProductInformationsFilter({
  size,
  index,
  searchTerm,
  orderBy,
  className,
  deviceInfo,
  model,
  stockNumber,
  mlfbNumber,
  installyear,
  manufacturer,
}) {
  const t = localStorage.getItem('fetchInventoryProductInformationsFilter')
  if (t !== undefined && t != null) {
    try {
      const fe = JSON.parse(t)
      if (fe != null) {
        if (size === undefined) size = fe.size || size
        if (index === undefined) index = fe.index || index
        if (searchTerm === undefined) searchTerm = fe.searchTerm || searchTerm
        if (orderBy === undefined) orderBy = fe.orderBy || orderBy
        className = fe.className || className
        deviceInfo = fe.deviceInfo || deviceInfo
        model = fe.model || model
        className = fe.className || className
        stockNumber = fe.stockNumber || stockNumber
        mlfbNumber = fe.mlfbNumber || mlfbNumber
        installyear = fe.installyear || installyear
        model = fe.model || model
        manufacturer = fe.manufacturer || manufacturer
      }
    } catch (e) {
      console.log(e)
    }
  }
  size = size || localStorage.getItem('pageSize') || 15
  try {
    localStorage.setItem(
      'fetchInventoryProductInformationsFilter',
      JSON.stringify({
        size,
        index,
        searchTerm,
        orderBy,
        className,
        deviceInfo,
        model,
        stockNumber,
        mlfbNumber,
        installyear,
        manufacturer,
      }),
    )
  } catch (e) {
    console.log(e)
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(
    list2,
    size,
    index,
    searchTerm,
    orderBy,
    className,
    deviceInfo,
    model,
    stockNumber,
    mlfbNumber,
    installyear,
    manufacturer,
  )
  yield put({
    type: actions.LIST_INVENTORYPRODUCTINFORMATION,
    result,
  })
}

export default function* rootSaga() {
  yield all([
    // takeEvery(actions.FETCH_INVENTORYPRODUCTINFORMATIONS, fetchInventoryProductInformations),
    takeEvery(actions.FETCH_INVENTORYPRODUCTINFORMATION, fetchInventoryProductInformationEdit),
    takeEvery(actions.SAVE_INVENTORYPRODUCTINFORMATION, saveMlfb),
    takeEvery(actions.DELETE_INVENTORYPRODUCTINFORMATION, fetchInventoryProductInformationDelete),
    takeEvery(
      actions.RE_FETCH_INVENTORYPRODUCTINFORMATIONS,
      fetchInventoryProductInformationsFilter,
    ),
    takeEvery(
      actions.FETCH_INVENTORYPRODUCTINFORMATIONS_FILTER,
      fetchInventoryProductInformationsFilter,
    ),
  ])
}
